import {Box, Typography} from '@mui/material';
import ArrDataGridPro from '../../../common/arr-data-grid-pro/ArrDataGridPro';
import {t} from 'i18next';
import './SummarizeDataGrid.scss';
import {ReactComponent as NoDataIcon} from '../../../../assets/images/no-data-found.svg';
import ArrToastNotification from '../../../common/arr-toast-notification/ArrToastNotification';
import ArrLoadingSpinner from '../../../common/arr-loading-spinner/ArrLoadingSpinner';
import {UseSummarizedGrid} from './SummarizeDataGridController';
import {columns} from './SummarizeDataGridData';
import SummaryDeleteModal from '../summary-delete-modal/SummaryDeleteModal';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const NoRowsOverlay = () => (
  <Box className="no-grid-overlay">
    <NoDataIcon />
    <Typography
      tabindex={0}
      className="typo-text headline3_size"
      data-testid="no-meta-result"
    >
      {t('ai.summarize.grid.messageNoData')}
    </Typography>
  </Box>
);

const SummarizeDataGrid = () => {
  const {
    onDeleteData,
    onRetryData,
    openDeleteModal,
    showToast,
    toastMessage,
    toastStatus,
    handleDeletePress,
    isLoadingDelete,
    isLoadingRetry,
    selectedJobId,
    setShowToast,
    setToastMessage,
    filterModel,
    setFilterModel,
    handleSortModelChange,
    sortModel,
    setPageSize,
    pageSize,
    setPageNumber,
    pageNumber,
    summarizeJobData,
    summarizeDataLoading,
    navigationDocs,
    navigationLoading,
    isLoading,
  } = UseSummarizedGrid();

  const hasGridData = (summarizeJobData?.totalRecords ?? 0) > 0;

  return (
    <Box className="ai-summarize-data-grid" data-testid="history-grid-wrapper">
      <ArrDataGridPro
        rows={summarizeJobData?.jobDetailsDtos ?? []}
        columns={columns(handleDeletePress, onRetryData, navigationDocs)}
        density="compact"
        disableVirtualization
        headerFilters
        showPerPageOptions
        pagination
        getDetailPanelHeight={() => 'auto'}
        onDetailPanelExpandedRowIdsChange={() => {}}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        onSelectionStateChange={() => {}}
        noRowsOverlay={NoRowsOverlay}
        itemsPerPage={pageSize}
        setItemsPerPage={setPageSize}
        onPageChange={setPageNumber}
        currentPage={pageNumber}
        rowCount={summarizeJobData?.totalRecords}
        entityType={t('ai.summarize.grid.entries')}
        hideFooter={summarizeJobData?.totalRecords === 0}
        filterModel={filterModel}
        sortModel={hasGridData ? sortModel : []}
        onSortModelChange={hasGridData ? handleSortModelChange : undefined}
        disableColumnSorting={!hasGridData}
        data-testid="summarize-data-grid"
        onFilterModelChange={setFilterModel}
        filterMode="server"
        paginationMode="server"
        primaryKey="jobId"
        loading={summarizeDataLoading}
        disableColumnResize={false}
        hideFilterIcon={true}
      />
      {showToast && (
        <ArrToastNotification
          message={toastMessage}
          onClose={() => {
            setToastMessage('');
            setShowToast(false);
          }}
          status={[toastStatus]}
        />
      )}
      {(isLoadingDelete ||
        isLoadingRetry ||
        navigationLoading ||
        isLoading) && <ArrLoadingSpinner overlay isOpen />}
      <SummaryDeleteModal
        jobId={selectedJobId?.jobId}
        open={openDeleteModal}
        handleYesPress={onDeleteData}
        handleGoBack={handleDeletePress}
        isCancel={
          selectedJobId?.status === 'InQueue' ||
          selectedJobId?.status === 'InRetryQueue'
        }
      />
    </Box>
  );
};

export default SummarizeDataGrid;
